import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InfoIcon } from '../../../../components/info-icon';
import { thousandSeparator } from '../../../reqs-filter/utils';

const CustomCell = ({ field, row }) => {
	if (field === 'id') {
		return (
			<div className="custom-cell__id">
				<InfoIcon popupContent={`№ ${row[field]}`} />
			</div>
		);
	}

	if (field === 'link' && row[field]) {
		return (
			<a
				className="custom-cell__link"
				target={row[field].target ? row[field].target : '_self'}
				href={row[field].url}
			>
				{row[field].text}
			</a>
		);
	}

	if (field === 'status_id') {
		return (
			<div className="custom-cell-process__planning">
				<div className={`status-indicator status-indicator_${row.status.color}`} />
				<div className="custom-cell-process">{row.status.name}</div>
			</div>
		);
	}

	if (field === 'address_from' && row.address_from) {
		return (
			<Link className="custom-cell__link" to={row.address_from.link}>
				{row.address_from.address}
			</Link>
		);
	}

	if (field === 'address_to' && row.address_to) {
		return (
			<Link className="custom-cell__link" to={row.address_to.link}>
				{row.address_to.address}
			</Link>
		);
	}

	if (field === 'cost' && row.cost) {
		return `${thousandSeparator(row.cost)} руб`;
	}

	if (field === 'orders_sum_cost' && row.orders_sum_cost) {
		return `${thousandSeparator(row.orders_sum_cost)} руб`;
	}

	if (field === 'orders_sum_weight' && row.orders_sum_weight_with_rate) {
		return `${row.orders_sum_weight_with_rate}/${row.weight_with_recycling ?? ''}`;
	}

	if (field === 'orders_sum_volume' && row.orders_sum_volume_with_rate) {
		return `${row.orders_sum_volume_with_rate}/${row.volume_with_recycling ?? ''}`;
	}

	return row[field];
};

CustomCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { CustomCell };
